/*
 * @Author: cc
 * @Date: 2023-04-27 16:31:42
 * @LastEditors: cc
 * @LastEditTime: 2023-05-23 16:53:38
 * @Description: 接口
 * @FilePath: \vue3-zhongjiane:\东方热线\IntermediateH5\src\assets\js\api.js
 */
let root_url = "https://www-api.ccicnb.com/ccicnb-main-provider" //正式地址
let gzh = 'https://www-api.ccicnb.com/ccicnb-main-provider'
// let root_url = "https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider" //正式地址
// let log = 'https://ccicnb-test-biz.cnool.net/auth-provider/'
console.log(process.env.NODE_ENV,'NODE_ENV111')
console.log(process.env.VUE_APP_MODE,'VUE_APP_MODE');
if(process.env.NODE_ENV == 'buildtest' || process.env.NODE_ENV == 'development') {
        root_url = 'https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider'
        gzh = 'https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider'
}
if (process.env.NODE_ENV == 'production') {
    root_url = "https://www-api.ccicnb.com/ccicnb-main-provider"
    gzh = 'https://www-api.ccicnb.com/ccicnb-main-provider'
} else {
    root_url = 'https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider'
    gzh = 'https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider'
}

// if (process.env.NODE_ENV == 'development') {
//   // root_url = "https://www-api.ccicnb.com/ccicnb-main-provider"
//   root_url = "https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider"
// } else {
//   if (process.env.VUE_APP_MODE == 'buildtest') {
//     root_url = "https://ccicnb-ins-test-biz.cnool.net/ccicnb-main-provider"
//   } else {
//     root_url = "https://www-api.ccicnb.com/ccicnb-main-provider" //正式地址
//   }
// }

export default {
  root_url,
  gzh,
  servepage: root_url + '/wx/category/getTree', //服务
  // category: root_url + '/wx/category/baseInfo',//服务详情
  getNewsTitle: root_url+ '/wx/category/getNesCategory',//新闻标题
  getNewsDetails: root_url + '/wx/news/getNewsPage' ,// 新闻分页
  baseInfo: root_url + '/wx/news/baseInfo',//新闻详情
  // searchMessage: root_url + '/wx/search/search', //搜索
}